import * as React from 'react';
import './styles/SidebarRoute.scss';

interface IProps {
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  children: any;
}

const SidebarRoute: React.FC<IProps> = (props) => {
  return (
    <div className="sidebar-route">
      {props.iconLeft}
      <div className="sidebar-route-title">
        {props.children}
      </div>
      {props.iconRight && (
        <div className="sidebar-route-right">
          {props.iconRight}
        </div>
      )}
    </div>
  );
};

export default SidebarRoute;
